import { Subscription } from 'rxjs/Subscription';
import { Component, OnInit } from '@angular/core';
import { BaseComponentService } from '../../../services/base-component.service';
import { AslibModalComponent, IAslibModalOptions } from '@aslib/modal';
import { AslibGridComponent } from '@aslib/components';

@Component({
  selector: 'gpa-empenho-processado',
  templateUrl: './processado.component.html',
  providers: [BaseComponentService]
})

export class ProcessadoComponent extends BaseComponentService implements OnInit {

  listaProcessado: any[];
  permitirEnvio: boolean;

  /**
   * ngOnInit
   *
   */
  ngOnInit() {
    this.permitirEnvio = false;
    this.listaProcessado = [];

    // Fica escutando o idFileCaptured para carregar a grid
    if (sessionStorage.getItem('IdPed') != null) {
      const ped = Number(sessionStorage.getItem('IdPed'));
      this.getPEDProcessed(ped);
    } else {
      this.listaProcessado = [];
    }
  }

  getPEDProcessed(fileId: number) {
    this._service.routePrefix = '/api/PedRetorno/ObterPedsRetornados'.concat(`/${fileId}/${true}`);

    this.permitirEnvio = false;
    this.listaProcessado = [];

    this.aslibLoadingService.start();

    this.subListar = this._service.getAll('gpa').subscribe(data => {
      this.aslibLoadingService.complete();

    this.listaProcessado = data;

      if (this.listaProcessado && this.listaProcessado.length > 0) {
        if(data[0].todasComErro== true) {
          this.listaProcessado = null;
          this.exibirAviso('Todas os PEDS contem erro. Verifique a aba de Não Processados!');
        }else{
            
            this.permitirEnvio = !this.listaProcessado[0].enviadoNoEMP;
        }
      }
      
      else {
        this.exibirAviso('Arquivo em processamento.');
      }
    },
      (error) => {
        this.aslibLoadingService.complete();
        this.exibirErro(error);
      },
      () => {
        this.aslibLoadingService.complete();
      }
    );
  }

  enviarEMP(grid: AslibGridComponent) {
    if (this.listaProcessado.length === 0) {
      this.exibirAviso('Não há dados para a geração e envio do EMP.');
      return;
    }

    this._service.routePrefix = '/api/EmpEnvio';

    this.aslibLoadingService.start();

    this.subSave = this._service.add(this.listaProcessado, 'gpa').subscribe(data => {
      this.permitirEnvio = false;

      // atualiza a coluna de sinalização de envio.
      for (let index = 0; index < this.listaProcessado.length; index++) {
        this.listaProcessado[index].enviadoNoEMP = true;
      }

      this.exibirSucesso('Os EMPs foram enviados com sucesso.');
    },
      erro => {
        this.aslibLoadingService.complete();
        this.exibirErro(erro);
      },
      () => {
        this.aslibLoadingService.complete();
      }
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/pagamento/empenho/processado/processado.component.ts